import { useTable } from "react-table";
import { useMemo } from "react";
import {
  getDurationTime,
  setToDateMonthYearInWordsByOnLocal,
  toAmPm,
} from "../../../../../helpers";

export const useBookingInfo = ({ bookings = [] }) => {
  const columns = useMemo(
    () => [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ cell: { value } }) =>
          setToDateMonthYearInWordsByOnLocal(value),
      },

      {
        Header: "Time",
        accessor: "bookings",
        Cell: ({ cell: { value } }) =>
          value?.map((booking, index) => (
            <span key={index}>
              {toAmPm(booking?.start_time)} -{" "}
              {toAmPm(getDurationTime(booking?.start_time, booking?.duration))}
              {value?.length - 1 === index ? "" : ", "}
            </span>
          )),
      },
    ],
    [],
  );

  const instance = useTable({
    columns: columns,
    data: bookings,
  });

  return {
    instance,
  };
};
